<template>
  <div id="app">
    <find-box></find-box>
    <!--  <router-view></router-view> -->
  </div>
</template>
<script>
import findBox from "@/components/find.vue";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // 页面加载时，读取sessionStorage中的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    // 在页面刷新时，将vuex中的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    // 在页面加载时读取sessionStorage里的状态信息
    sessionStorage.getItem("umeetCloudVuex") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(sessionStorage.getItem("umeetCloudVuex"))
        )
      );
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem(
        "umeetCloudVuex",
        JSON.stringify(this.$store.state)
      );
    });
  },
  components: {
    findBox
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.setWza();
    // this.setFoot();
  },
  methods: {
    setFoot() {
      console.log("a");
      let nav = document.createElement("script");
      nav.charset = "UTF-8";

      nav.src =
        "https://zwfw.nmg.gov.cn/portal/js/common_style/common_bottom_app.js";
      console.log(nav);

      document.getElementById("customFooter").appendChild(nav); //外部链接需要调用
    },
    setWza() {
      let nav = document.createElement("script");
      nav.charset = "UTF-8";
      nav.src =
        "https://auth.mangren.com/boots/mqtpc.huaxun.ink/esdToolsInit.js";
      document.body.appendChild(nav); //外部链接需要调用
    }
    // setFoot() {
    //   let nav = document.createElement("script");
    //   //  nav.charset = "UTF-8";

    //   nav.src =
    //     "https://zwfw.nmg.gov.cn/portal/js/common_style/common_bottom_app.js";

    //   document.getElementById("customFooter").appendChild(nav); //外部链接需要调用
    // }
  }
};
</script>

<style>
.zwfw_header_top_right_t{
  text-align: right;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
body {
  margin: 0;
  padding: 0;
  /* overflow-x:hidden; */
}
/deep/#app {
  min-width: 1850px;
  max-width: 100%;
  background: #f5fafd;
}
.pagination {
  padding-top: 80px;
}
/deep/.el-pagination {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue